import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import TamariskPaymentsStore from '../stores/tamariskPaymentsStore';

export const useTamariskPaymentsStore = () => useContext<{
  tamariskPaymentsStore: TamariskPaymentsStore
}>(StoreContext);
